/* eslint-disable react/prop-types */
import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedManufacturer,
  setSelectedBrand,
  setSelectedClass,
  setSelectedSKUs,
  setSelectedWeekStart,
  setSelectedWeekEnd,
} from "../../../Redux/promoSimulatorSlice/promoSimulatorSlice";

import { PROMO_ALL_BRANDS_ID, PROMO_ALL_CLASSES_ID } from "../services/promoSimulatorService";

export const PROMO_SIMULATOR_MANUFACTURERS = [];

export default function ManufacturerSelector({
  formControlSx,
  manufacturers = PROMO_SIMULATOR_MANUFACTURERS,
  loading = false,
}) {
  const dispatch = useDispatch();
  const selectedManufacturer = useSelector(
    (state) => state.promoSimulator.selectedManufacturer
  );

  const selectedIds = manufacturers.map((m) => m.id);
  const selectValue =
    selectedManufacturer && selectedIds.includes(selectedManufacturer)
      ? selectedManufacturer
      : selectedIds[0] ?? "";

  const handleChange = (e) => {
    dispatch(setSelectedManufacturer(e.target.value));
    dispatch(setSelectedBrand(PROMO_ALL_BRANDS_ID));
    dispatch(setSelectedClass(PROMO_ALL_CLASSES_ID));
    dispatch(setSelectedSKUs([]));
    dispatch(setSelectedWeekStart(null));
    dispatch(setSelectedWeekEnd(null));
  };

  return (
    <FormControl fullWidth size="small" sx={formControlSx} disabled={loading}>
      <InputLabel>Manufacturer</InputLabel>
      <Select
        value={selectValue}
        label="Manufacturer"
        onChange={handleChange}
      >
        {manufacturers.map((m) => (
          <MenuItem key={m.id} value={m.id}>
            {m.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
